import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryImages = [
  'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20illustration%20with%20dramatic%20action%20scene%2C%20powerful%20characters%20with%20dynamic%20poses%2C%20modern%20Korean%20webtoon%20aesthetic%2C%20vibrant%20colors%20with%20dark%20accents%2C%20digital%20art%20style%2C%20clean%20composition&width=600&height=400&seq=cat-korean-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Japanese%20manga%20style%20illustration%20with%20classic%20shonen%20characters%2C%20bold%20line%20art%2C%20expressive%20faces%2C%20traditional%20manga%20screentone%20pattern%2C%20action%20manga%20aesthetic%2C%20dynamic%20composition&width=600&height=400&seq=cat-japanese-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Chinese%20manhua%20style%20illustration%20with%20elegant%20martial%20arts%20characters%2C%20traditional%20Chinese%20ink%20painting%20influence%2C%20flowing%20robes%2C%20ancient%20Chinese%20architecture%20background%2C%20refined%20color%20palette%2C%20digital%20art&width=600&height=400&seq=cat-chinese-01&orientation=landscape',
];

export default function CategorySection() {
  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h3 className="text-xl md:text-2xl font-heading text-foreground-900">漫画分类</h3>
          <p className="text-sm text-foreground-500 mt-1">按类型找到你喜欢的漫画</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat, i) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative h-48 md:h-56 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={categoryImages[i]}
                alt={cat.name}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-foreground-950/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-center gap-2 mb-1">
                  <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-500/90 text-white">
                    <i className={`${cat.icon} text-base`}></i>
                  </div>
                  <span className="text-white text-lg font-heading">{cat.name}</span>
                </div>
                <p className="text-white/70 text-xs">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}